import * as yup from "yup";

import { summaryConsentValidatorRequired } from "../../../../utilities/validators/summaryConsent";

import { ComponentId } from "./enums";

export const validator = yup.object().shape({
  [ComponentId.CORRECTNESS_AGREEMENT]: summaryConsentValidatorRequired,
  [ComponentId.CONTACT_AGREEMENT]: summaryConsentValidatorRequired,
});
